import { render, staticRenderFns } from "./resourceBox.vue?vue&type=template&id=7864d1ec&scoped=true"
import script from "./resourceBox.vue?vue&type=script&lang=js"
export * from "./resourceBox.vue?vue&type=script&lang=js"
import style0 from "./resourceBox.vue?vue&type=style&index=0&id=7864d1ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7864d1ec",
  null
  
)

export default component.exports